<template>
    <span>
        <home-hero headline="Project so far" text=""></home-hero>
        <v-container>
            <h1></h1>
            <!--<div>
                HYPOTHESIS ESTIMATED SPREAD - The real number of infected people
                is at least 300% higher than officially reported numbers
                BREATHING SOUNDS - We aim to use mobile devices and a telephone
                chat bot to record breathing sounds and identify change points
                in these sounds that indicate a worsening of an infected person.
                The monitoring system can be used in hospitals and from home.
                EPIDEMIC MODEL - SIR/SEIR models are used to simulate virus
                outbreaks. We are building a product to estimate their
                parameters and use them for long term predictions POSTULATE
                HYPOTHESIS - We collect and decide upon hypothesis to evaluate
                UNIFIED DATA PIPELINE - We build a data pipeline that acquires
                data from multiple sources, combines and aggregates them and
                provides high quality data to the public 1. Mission and goals of
                the work stream To create a unified hub of data sources and
                support the build of a pipeline according to Project Athena
                needs. Team Hub (Includes deliverables tracker):
                https://docs.google.com/spreadsheets/d/1Z2lUpO5NDPYfu8J6Kj1I_EfrC1HCslFXyLpbWIi0mVw
                2. Link to the backlog
                https://trello.com/invite/b/EZUv2SEW/99c85d2b0b6858f835bca464418b04b4/project-athena-unifieddatapipe
                3. What will you post on our website about your work stream -
                think of success stories, achievements, reports, visualisations,
                contributors, skills needed, support needed etc. 4. When do you
                expect to make an impact with your work stream and what do you
                need to make it happen now? The team expects to have their first
                Deliverable (Total Cases by County) in storage by Thursday 10th
                April 2020. (Storage build has been initiated today) 5. What are
                impediments that you are facing? No huge blockers at the moment
                for the collect and clean sub teams, we are chipping away and
                making good progress with our first deliverable. Awaiting
                blockers from the build/storage sub team.
            </div>-->
        </v-container>
        <home-projects></home-projects>

        <home-footer></home-footer>
    </span>
</template>

<script>
import HomeHero from '@/components/HomeHero';
import HomeFooter from '@/components/HomeFooter';
import HomeProjects from '@/components/HomeProjects';

export default {
    name: 'projects',
    components: {
        HomeHero,
        HomeProjects,
        HomeFooter
    }
};
</script>
